import React, { useEffect, useState } from "react";
import Container from "react-bootstrap/Container";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Error from "./components/Error/Error";
import Landing from "./page/Landing/Landing";
import Information from "./page/Information/Information";
import Status from "./page/Status/Status";
import appConfig from "./config/app.config";
import SiteStatusService from "./services/api/site_status/status.service";
import "./App.css";

function App() {
  const [status, setStatus] = useState({ maintenance: false, disabled: false });

  const fetchSiteStatus = async () => {
    try {
      const result = await SiteStatusService.fetchSiteStatus();
      if (result.status === 200 && result.data?.data) {
        setStatus({
          maintenance: !!result.data.data.maintenance,
          disabled: !!result.data.data.disable,
        });
      } else {
        setStatus({ maintenance: false, disabled: false });
      }
    } catch (err) {
      setStatus({ maintenance: false, disabled: false });
    }
  };

  useEffect(() => {
    fetchSiteStatus();
  }, []);

  // 👉 Put route output into a function
  const renderContent = () => {
    if (status.maintenance) {
      return (
        <Error
          header="Maintenance"
          description="The site is under maintenance. Please check back later."
        />
      );
    }

    if (status.disabled) {
      return (
        <Error
          header="Disabled"
          description="The site is currently disabled. Please contact support."
        />
      );
    }

    return (
      <Routes>
        <Route
          path={`${appConfig.app.subDir}:qcuserid`}
          element={<Landing />}
        />
        <Route
          path={`${appConfig.app.subDir}information/:qcuserid`}
          element={<Information />}
        />
        <Route
          path={`${appConfig.app.subDir}status/:qcuserid`}
          element={<Status />}
        />
        <Route
          path={`${appConfig.app.subDir}`}
          element={
            <Error
              header="Access Denied"
              description="You don't have permission to view this site"
            />
          }
        />
        <Route
          path="*"
          element={
            <Error
              header="404 Not Found"
              description="The page you are looking for does not exist"
              btnTxt="RETURN"
            />
          }
        />
      </Routes>
    );
  };

  return (
    <BrowserRouter>
      <Container fluid>{renderContent()}</Container>
    </BrowserRouter>
  );
}

export default App;
